import styled from 'styled-components'

const colors = {
  1: 'var(--success)',
  2: 'var(--danger)'
}

export const View = styled.strong`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  width: 91px;
  color: #fff;
  border-radius: 215px;
  padding-bottom: 4px;
  background: ${({ status }) => colors[status]};
`
